import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const QuantitySelector = ({ isSmall, quantity, articleNumber, onChange, packagingQuantity, sectionId, singleQuantity }) => (
    <div className={'quantity-box' + (isSmall ? ' quantity-box--small' : '')}>
        {quantity === 0 ? (
            <a className="quantity-box__add" onClick={() => onChange(articleNumber, packagingQuantity, quantity, sectionId)}>
                <span>{translate("quantityselector.add")}</span>
                <svg>
                    <use href="/ui/images/tibergs-svg/sprite/sprite.svg#plus"></use>
                </svg>
            </a>
        ) :
            (
                <Fragment>
                    <a className="quantity-box__update" onClick={() => onChange(articleNumber, (-1 * packagingQuantity), quantity, sectionId)}>
                        <svg className={`${quantity === 1 ? 'quantity-box__remove' : ''}`}>
                            {quantity === 1 ? (
                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#trashcan"></use>
                            ) : (
                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#minus"></use>
                            )}
                        </svg>
                    </a>
                    <span className="quantity-box__quantity">{quantity}</span>
                    {!singleQuantity &&
                        <a className="quantity-box__update" onClick={() => onChange(articleNumber, packagingQuantity, quantity, sectionId)}>
                            <svg>
                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#plus"></use>
                            </svg>
                        </a>
                    }
                </Fragment>
            )
        }
    </div>
)

export default QuantitySelector;